/* eslint-disable complexity */
import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux';
import { Form, Input, Modal, Button, message } from 'antd';
import { apifileupload, apiChangePic,apiEditUserInfo,apiChangePassward } from '../../../shared/api.js';
import { openLoginModal, logout,getUserInfo } from '../../common/LoginModal/store';
import { Picture } from '@portal-site/components';
import Default from '@/assets/images/desktop/common/default.jpg';
import './index.scss'
import $ from 'jquery';

const Infor = () => {
  const [show, setShow] = useState(true);
  const { userInfo } = useSelector((state) => state.loginModalReducer);
  const [emailshow, setEmailshow] = useState(true);
  const [dialog, setDialog] = useState(false);
  const [fileId, setFileId] = useState();
  const [filePath, setfilePath] = useState();
  const [showEditPws, setShowEditPwd] = useState(false);
  const dispatch = useDispatch();
  // 上传图片
  const onImgChange = (e) => {
    const a = {
      description: '头像',
      dirNameCn: '',
      dirNameEn: '',
      file: e?.target?.files?.[0]
    };
    function objectToFormData(obj) {
      let formData = new FormData();
      Object.keys(obj).forEach((key) => {
        if (obj[key] instanceof Array) {
          obj[key].forEach((item) => {
            formData.append(key, item);
          });
          return;
        }
        formData.append(key, obj[key]);
      });
      return formData;
    }
    const formdata = objectToFormData(a);
    apifileupload(formdata).then((res) => {
      // setImg1(res?.data?.fileInfoId);
      setFileId(res?.fileInfoId);
      setfilePath(res?.filePathThumbStr);
    });
  };
  // 保存图片
  const submit = () => {
    const params = {
      userId:userInfo.userId,
      profilePic:filePath
    };
    apiEditUserInfo(params).then((res) => {
      if (res.data) {
        message.success('修改头像成功');
        setDialog(false);
        dispatch(getUserInfo());
      } else {
        message.error('修改头像失败');
      }
    });
  };
  // 取消修改
  const cancel = () => {
    setFileId(null);
    setfilePath(null);
    setDialog(false);
  };
  // 登出
  const handleLogOut = () => {
    dispatch(logout());
    dispatch(openLoginModal());
  };
  // 修改密码
  const handleChange = (value) => {
    apiChangePassward({
      newPassword: value.newPassword,
      oldPassword: value.oldPassword,
    }).then(res => {
      if (res.code === 200) {
        message.success('修改密码成功,请重新登录');
        handleLogOut();
      }else{
        message.error(res.msg)
      }
    })
  }
  // 修改个人信息
  const editNickName = () => {
    let val = $('input.edit').val();
    let reg = /^[a-zA-Z0-9_\u4e00-\u9fa5]{2,12}$/;
    if (reg.test(val)) {
      apiEditUserInfo({userId:userInfo.userId,nickName:val}).then(res => {
        if (res.code === 200) {
          message.success('修改昵称成功');
          setShow(true);
          dispatch(getUserInfo());
        } else {
          message.error('修改昵称失败');
        }
      })
    } else {
      message.error('请输入2-12位字符，推荐使用简单的汉字、字母、数字组合');
    }
  }
  return (
    <div className="personal-common">
      {
        !showEditPws ? 
        (<div className='person-info'>
        <div className='p-head'>
          <div className="p-title">我的信息</div>
        </div>
        <div className="infor-box">
          <ul className="infor-list">
            <li>
              <span>当前头像</span>
              <div className="avatar" onClick={() => setDialog(true)}>
                <img className={`avatar-logo `} src={userInfo.profilePic ? `${window.ENV_API}/${userInfo.profilePic}` : Default} alt="" />
              </div>
            </li>
            <li>
              <span>当前昵称</span>
              <div className='nick'>
                {
                  show ?
                  (<div className='name'>{userInfo.nickName ? userInfo.nickName : '未填写'}</div>)
                  :
                  (<input className="ant-input edit" type="text" onBlur={()=>editNickName()}/>)
                }
                <svg t="1667786587368" onClick={() => { 
                  setShow(!show); 
                }} className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2721" width="40" height="40"><path d="M775.84 392.768l-155.2-172.352L160.768 643.264l-38.368 187.936 190.56-12.832zM929.952 229.952l-131.2-150.944-0.288-0.32a16 16 0 0 0-22.592-0.96l-131.168 120.576 155.168 172.352 128.832-118.464a15.936 15.936 0 0 0 1.248-22.24zM96 896h832v64H96z" fill="#ED5735" p-id="2722"/></svg>
                {/* <i
                  className='iconfont icon-zhanghuxinxixiugai'
                  onClick={() => { setShow(!show); }}
                /> */}
              </div>
            </li>
            <li>
              <span>用户ID</span><p>{userInfo.userId || '未填写'}</p>
            </li>
            {/* <li>
              <span>登录名</span><p>{userInfo.username || '未填写'}</p>
            </li>
            <li>
              <span>手机号</span><p>{userInfo.phoneNum || '未填写'}</p>
            </li>
            <li>
              <span>邮箱</span>
              <div className='nick'>
                {emailshow && <div className='name'>{userInfo.emailAddr || '未填写'}</div>}
                <i
                  className='iconfont icon-zhanghuxinxixiugai'
                  onClick={() => { setEmailshow(!emailshow) }}
                />
              </div>
            </li> */}
          </ul>
          <Modal
          className="avatar-dialog-box"
          title="上传头像"
          centered
          visible={dialog}
          // onOk={() => setDialog(false)}
          onCancel={() => setDialog(false)}
          footer={[
            <div className="filebox" key="uploadbtn">
              <input
                type="file"
                // 需要直接唤起相机的时候
                // capture="camera"
                accept="image/jpg,image/jpeg,image/bmp,image/png"
                multiple={false}
                onChange={(e) => {
                  onImgChange(e);
                }}
              />
            </div>,
            <Button key="upbtn" type="primary">
              上传头像
            </Button>,
            <Button
              key="cancel"
              onClick={() => {
                cancel();
              }}
            >
              取消
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={() => {
                submit();
              }}
            >
              保存
            </Button>
          ]}
        >
          <div className="up-box">
            <div className="imgstyle">
              <Picture
                source={
                  filePath
                    ? `${window.ENV_API}/${filePath}`
                    : `${window.ENV_API}/file/getThumb/${userInfo.fileId}`
                }
              />
            </div>
            <p className="annotation">
              请选择图片上传：大小180*180像素，支持JPG、PNG等格式，图片需小于2M。
            </p>
          </div>
        </Modal>
        </div>
        <div className='p-head'>
          <div className="p-title second-title">注册信息</div>
        </div>
        <div className="infor-box">
          <ul className="infor-list">
            <li>
              <span>登录账号</span>
              <p>{userInfo.username || '未填写'}</p>
            </li>
            <li>
              <span>登录密码</span>
              <p>
                ******
                <svg t="1667786587368" onClick={()=>{setShowEditPwd(true);}} className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2721" width="40" height="40"><path d="M775.84 392.768l-155.2-172.352L160.768 643.264l-38.368 187.936 190.56-12.832zM929.952 229.952l-131.2-150.944-0.288-0.32a16 16 0 0 0-22.592-0.96l-131.168 120.576 155.168 172.352 128.832-118.464a15.936 15.936 0 0 0 1.248-22.24zM96 896h832v64H96z" fill="#ED5735" p-id="2722"/></svg>
              </p>
            </li>
          </ul>
        </div>
        </div>)
        :
        (<div className="changepassword">
          <Form
            className="changep-form"
            onFinish={(value) => {
              handleChange(value)
            }}
          // initialValues={{
          //   telNum: telNum,
          //   newpassword: '',
          //   confirm: '',
          // }}
          // onValuesChange={(val) => {
          //   if (val?.authCode) {
          //     setAuthCode(val?.authCode);
          //   }
          //   if (val?.newpassword) {
          //     setPassword(val?.newpassword);
          //   }
          // }}
          >
            <Form.Item
              label="原始密码"
              rules={[
                { required: true, message: '请输入原始密码' },
                {
                  pattern: /^[a-zA-Z0-9_]{6,18}$/,
                  message: '请输入6-18位字母、数字组合'
                }
              ]}
              name="oldPassword"
            >
              <Input.Password placeholder="请输入原始密码" block="true" size="large" />
            </Form.Item>
            <Form.Item
              label="新密码"
              rules={[
                { required: true, message: '请输入新密码' },
                {
                  pattern: /^[a-zA-Z0-9_]{6,18}$/,
                  message: '请输入6-18位字母、数字组合'
                }
              ]}
              name="newPassword"
            >
              <Input.Password placeholder="新密码(6-18位字母、数字组合)" block="true" size="large" />
            </Form.Item>
            <Form.Item
              label="确认密码"
              name="confirm"
              dependencies={['newPassword']}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: '请再次输入新密码',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('两次密码不匹配'));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="新密码(6-18位字母、数字组合)" block="true" size="large" />
            </Form.Item>


            <Button
              className="button"
              // type="primary"
              block="true"
              size="large"
              htmlType="submit"
            // disabled={disabled}
            >
              保存
            </Button>
          </Form>
        </div>)
      }
    </div>
  )
}

export default Infor;
